import { Button } from 'antd';
import React from 'react';
import styles from './index.module.less';

export type BootstrapStateVariant = 'error' | 'warning' | 'readonly' | 'empty';

type Props = {
  variant?: BootstrapStateVariant;
  icon?: React.ReactNode;
  title: string;
  description: React.ReactNode;
  action?: { label: string; onClick: () => void; loading?: boolean };
};

const BootstrapStateView: React.FC<Props> = ({
  variant = 'empty',
  icon,
  title,
  description,
  action,
}) => (
  <div className={styles.wrapper}>
    <div className={`${styles.card} ${styles[variant]}`}>
      <div className={styles.icon}>{icon}</div>
      <h2 className={styles.title}>{title}</h2>
      <div className={styles.description}>{description}</div>
      {action ? (
        <Button
          type="primary"
          onClick={action.onClick}
          loading={action.loading}
        >
          {action.label}
        </Button>
      ) : null}
    </div>
  </div>
);

export default BootstrapStateView;
